__webpack_require__.p = "https://najz-jonatan.findings-dev.co/";